<template>
  <section>
    <b-row>
      <b-form-group class="col-sm-6" label="Warehouse:">
        <b-v-select
          :disabled="viewOnly"
          name="form-input-warehouseId"
          v-model="reportFilters.warehouseId"
          :searchable="true"
          :options="warehousesListAll"
        />
      </b-form-group>
      <b-form-group class="col-sm-6" label="Up To When:">
        <Flatpickr
          :disabled="viewOnly"
          v-model="reportFilters.upToWhen"
          :config="flatpickrConfigWithTime"
          class="form-control flatpickr-input"
          placeholder="Select date and time"
          name="upToWhen"
        />
      </b-form-group>
      <div class="col-sm-12 alert alert-info">
        <b>Note</b>: This report shows the historical inventory changes up to the selected date and time for the chosen warehouse.
      </div>
    </b-row>
  </section>
</template>

<script>
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'HistoricalInventoryReport-form',
  props: {
    reportFilters: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      flatpickrConfigWithTime: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        altFormat: 'j F Y, h:i K',
        altInput: true,
        time_24hr: false
      }
    }
  }
}
</script>

<style>

</style>
